import FacebookeCreateAccount from './FacebookCreateAccount'

export default FacebookeCreateAccount
